import { useState } from "react";

//interfaces
import { ActionFeedback } from "thrive-components";
import { IUseModeratedComment } from "@/interfaces/activityFeedNotifications";

//hooks
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";



const UseModeratedComment = ({activityId, isPopOut, timeStamp, dateStamp, comment, content, appDetails, onDeleteCommentClick, onLikeClick, notificationDetails, meta} : IUseModeratedComment) => {
    const [showDeleteFunctionality, setShowDeleteFunctionality] = useState<boolean>(false);;
    
    const screenClassName = !isPopOut ? "full-screen-styling" : "";
    const commentClassName = `${screenClassName} ${comment.isDeleted || content.isArchived ? "deleted-comment" : ""} warning-comment-wrapper`
    const commentTruncate = isPopOut ?  50 : 228;
    const hideMenu = content.isArchived || comment.isDeleted;
    const userCommentIsLiked = meta.hasLiked ?? false;
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const hasBeenDeleted = content.isArchived || comment.isDeleted;
    const deletedBannerMessage = comment.isDeleted ? "Comment deleted" : "Content archived";
    const showDeletedBanner = hasBeenDeleted;
    const showDeleteCommentButton = !showDeleteFunctionality && !hasBeenDeleted;
    const activityInfo = {
        className: screenClassName,
        time: isPopOut ? timeStamp : undefined,
        dateStamp: `${timeStamp} · ${dateStamp}`,
        appImageUrl: appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName: appDetails.isMultipleAppOrganisation ? appDetails.name : "",
        likes: meta.likeCount ?? 0,
        likesEnabled: meta.likesEnabled,
        commentsEnabled: meta.commentsEnabled,
        comments: meta.commentCount,
        isReply: true,
    };

    const handleLikeClick = meta.likesEnabled ? onLikeClick : undefined
    function onDelete(e?: any) {
        useHaltPropagation(e);
        onDeleteCommentClick && onDeleteCommentClick(activityId, appDetails.id, content.id, comment.commentId);
        setShowDeleteFunctionality(false);
    }

    function onShowDeleteFunctionalityClick(e?: any) {
        useHaltPropagation(e);
        if (!hasBeenDeleted) {
            setShowDeleteFunctionality(true);
        }
    };

    function onHideDeleteFunctionality(e?: any){
        useHaltPropagation(e);
        setShowDeleteFunctionality(false);
    }
    
    return {
        commentClassName, commentTruncate, showDeleteFunctionality, handleLikeClick, hideMenu, userCommentIsLiked, showFeedbackBanner, feedbackType,feedbackMessage, deletedBannerMessage, showDeletedBanner, showDeleteCommentButton, activityInfo, onDelete, onShowDeleteFunctionalityClick, onHideDeleteFunctionality
    }
};

export default UseModeratedComment